import { Component } from "react";
import type { ReactNode, ErrorInfo } from "react";
import AnalyticsGridView from "./AnalyticsGridView";
import { captureException } from '../client/utils/posthog';

class AnalyticsErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null; info: ErrorInfo | null }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null, info: null };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[AnalyticsErrorBoundary]", error, info);
    captureException(error, { componentStack: info.componentStack, source: 'AnalyticsErrorBoundary' });
    this.setState({ error, info });
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: "monospace", background: "#1a0000", color: "#ff6b6b", borderRadius: 8, margin: 16 }}>
          <h2 style={{ fontSize: 18, marginBottom: 8 }}>💥 Analytics crash</h2>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all", fontSize: 12, color: "#ffaaaa" }}>
            {this.state.error.toString()}
          </pre>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all", fontSize: 11, color: "#ff8888", marginTop: 12 }}>
            {this.state.info?.componentStack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function AnalyticsDashboard() {
  return (
    <AnalyticsErrorBoundary>
      <AnalyticsGridView readOnly={false} />
    </AnalyticsErrorBoundary>
  );
}
